import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AcceptInvitationComponent } from './components/accept-invitation/accept-invitation.component';
import { PlaidLinkComponent } from './components/plaid-link/plaid-link.component'; // <-- Adjust the path as needed
import { PersonalDetailsComponent } from './components/personal-details/personal-details.component';
import { RequestCreditLineComponent } from './components/request-credit-line/request-credit-line.component';
import { AboutBusinessComponent } from './components/about-business/about-business.component';
import { BusinessStructureComponent } from './components/business-structure/business-structure.component';
import { BusinessLocationComponent } from './components/business-location/business-location.component';
import { OwnershipDisclosureComponent } from './components/ownership-disclosure/ownership-disclosure.component';
import { AdditionalOwnersComponent } from './components/additional-owners/additional-owners.component';
import { AdditionalOwnerInfoComponent } from './components/additional-owner-info/additional-owner-info.component';
import { AdditionalOwnerAddressComponent } from './components/additional-owner-address/additional-owner-address.component';
import { LinkBankAccountComponent } from './components/link-bank-account/link-bank-account.component';
import { CertificationsComponent } from './components/certifications/certifications.component';
import { ApplicationPendingComponent } from './components/application-pending/application-pending.component';
import { ApplicationDeniedComponent } from './components/application-denied/application-denied.component';
import { ApplicationApprovedComponent } from './components/application-approved/application-approved.component';

const routes: Routes = [
  {
    path: 'application/pending',
    component: ApplicationPendingComponent
  },
  {
    path: 'application/declined',
    component: ApplicationDeniedComponent
  },
  {
    path: 'application/approved',
    component: ApplicationApprovedComponent
  },
  {
    path: 'plaid-test',
    component: PlaidLinkComponent
  },
  {
    path: 'test/:token',
    component: AcceptInvitationComponent,
    children: [
      {
        path: '',
        redirectTo: 'personal-details',
        pathMatch: 'full'
      },
      { path: 'personal-details', component: PersonalDetailsComponent },
      { path: 'certifications', component: CertificationsComponent },
      { path: 'request-credit-line', component: RequestCreditLineComponent },
      { path: 'about-business', component: AboutBusinessComponent },
      { path: 'business-structure', component: BusinessStructureComponent },
      { path: 'business-location', component: BusinessLocationComponent },
      { path: 'ownership-disclosure', component: OwnershipDisclosureComponent },
      { path: 'additional-owners', component: AdditionalOwnersComponent },
      { path: 'additional-owner-info/:id', component: AdditionalOwnerInfoComponent },
      { path: 'additional-owner-address/:id', component: AdditionalOwnerAddressComponent },
      { path: 'additional-owner-info', component: AdditionalOwnerInfoComponent },
      { path: 'additional-owner-address', component: AdditionalOwnerAddressComponent },
      { path: 'link-bank-account', component: LinkBankAccountComponent },
      { path: 'thank-you', component: ThankYouComponent }
    ]
  },
  {
    path: ':token',
    component: AcceptInvitationComponent,
    children: [
      {
        path: '',
        redirectTo: 'personal-details',
        pathMatch: 'full'
      },
      { path: 'personal-details', component: PersonalDetailsComponent },
      { path: 'certifications', component: CertificationsComponent },
      { path: 'request-credit-line', component: RequestCreditLineComponent },
      { path: 'about-business', component: AboutBusinessComponent },
      { path: 'business-structure', component: BusinessStructureComponent },
      { path: 'business-location', component: BusinessLocationComponent },
      { path: 'ownership-disclosure', component: OwnershipDisclosureComponent },
      { path: 'additional-owners', component: AdditionalOwnersComponent },
      { path: 'additional-owner-info/:id', component: AdditionalOwnerInfoComponent },
      { path: 'additional-owner-address/:id', component: AdditionalOwnerAddressComponent },
      { path: 'additional-owner-info', component: AdditionalOwnerInfoComponent },
      { path: 'additional-owner-address', component: AdditionalOwnerAddressComponent },
      { path: 'link-bank-account', component: LinkBankAccountComponent },
      { path: 'thank-you', component: ThankYouComponent }
    ]
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
